import React from 'react';
import './style.scss';

export default function aboutHero() {
  return (
    <section className="about__we-do">
      <div className="container">
        <h1>What we do</h1>
        <div className="two-side">
          <div className="meta-wrapper">
            <h6>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit.
              Voluptatibus fuga nihil animi dignissimos ratione optio nulla
              beatae ea fugit maxime quisquam earum deleniti aspernatur, cumque
              tempora nobis, minima facilis reprehenderit.
            </h6>
          </div>
          <div className="meta-wrapper">
            <h6>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit.
              Voluptatibus fuga nihil animi dignissimos ratione optio nulla
              beatae ea fugit maxime quisquam earum deleniti aspernatur, cumque
              tempora nobis, minima facilis reprehenderit.
            </h6>
          </div>
          <figure className="image-wrapper">
            <div className="image"></div>
          </figure>
          <div className="meta-wrapper">
            <h6>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae, aut
              sequi? Ipsum vitae reiciendis, esse dignissimos voluptatibus
              necessitatibus aut velit facere fuga earum delectus odit vero
              quos. Cum vel architecto eligendi nostrum ut eum laboriosam
              doloribus consectetur id mollitia praesentium reiciendis ea
              temporibus deserunt molestiae, doloremque qui nisi placeat sunt
              autem repellat totam cupiditate neque cumque. Sequi molestiae
              possimus veniam molestias ex laborum cupiditate, nisi, magnam
              porro perferendis numquam itaque!
            </h6>

            <h6>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Consequuntur neque ducimus ratione voluptatem molestiae eius totam
              assumenda nobis illo expedita?
            </h6>
          </div>
        </div>
      </div>
    </section>
  );
}
